import client from './client'

export default class CRUD {
  constructor (endpoint) {
    this.endpoint = endpoint
  }

  list (params) {
    const url = '/api' + this.endpoint
    return client.get(url, params)
  }

  getSingle (params) {
    const url = '/api' + this.endpoint
    return client.get(url, params)
  }

  get (id) {
    const url = '/api' + this.endpoint + '/' + id
    return client.get(url)
  }

  post (data) {
    const url = '/api' + this.endpoint
    return client.post(url, data)
  }

  put (id, data) {
    const url = '/api' + this.endpoint + '/' + id
    return client.put(url, data)
  }

  delete (id, params) {
    const url = '/api' + this.endpoint + '/' + id
    return client.delete(url, params)
  }
}
